import type { UseMutationOptions } from 'react-query';
import { useMutation } from 'react-query';
import { getPrivateApi } from '../../services/api';
import { InviteUserRequest } from '../../../../../libs/client/src/generated';

export function useInviteUser(options?: UseMutationOptions<void, unknown, InviteUserRequest>) {
  return useMutation({
    mutationFn: async ({ username, role, invitedBy, firstName, lastName }: InviteUserRequest) => {
      const api = getPrivateApi();

      await api.inviteUser({
        inviteUserRequest: {
          username,
          role,
          invitedBy,
          firstName,
          lastName,
        },
      });
    },
    ...options,
  });
}
